import { GeneralField } from '@formily/core'

import { FORM_CONTROLLER_NAME_PREFIX } from './constants'

type UseControlNameProps = {
  field: GeneralField
  formName?: string
}

/**
 * 给 form 表单中的 input 等控件设置唯一值
 */
export const generateControlName = ({
  field,
  formName
}: UseControlNameProps) => {
  return `${FORM_CONTROLLER_NAME_PREFIX}_${formName}_${field.path.toString()}`
}
